import React from "react";
import { createStyles, darken, Theme, Tooltip } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { green, grey, orange, red } from "@material-ui/core/colors";

interface IProps {
  title?: string;
  top: number;
  left: number;
  width: number;
  height: number;
  shape: string;
  pictureUrl: string;
  rotation: number;
  colorClass: "free" | "selected" | "busy" | "noAvailable";
  isSeatSelected?: boolean;
  status: string;
  textTooltip: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    divSeat: (props: any) => ({
      position: "absolute",
      // border: "1px solid #cf5023",
      left: `${props.left}px`,
      top: `${props.top}px`,
      textAlign: "center",
      lineHeight: `${props.height}px`,
      backgroundImage: `url(${props.pictureUrl})`,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat"
    }),
    divSeatNoPosition: (props: any) => ({
      position: "absolute",
      // border: "1px solid #cf5023",
      textAlign: "center",
      lineHeight: `${props.height}px`,
      backgroundImage: `url(${props.pictureUrl})`,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat"
    }),
    CIRCLE: (props: any) => ({
      borderRadius: "50%",
      height: props.height,
      width: props.width,
      transform: `rotate(${props.rotation}deg)`
    }),
    SQUARE: (props: any) => ({
      height: props.height,
      width: props.width,
      transform: `rotate(${props.rotation}deg)`
    }),
    quarterCircleTopRight: (props: any) => ({
      height: props.height,
      width: props.width,
      transform: `rotate(${props.rotation}deg)`,
      borderRadius: `0 ${props.height}px 0 0`,
      MozBorderRadius: `0 ${props.height}px 0 0`,
      WebkitBorderRadius: `0 ${props.height}px 0 0`
    }),
    quarterCircleTopLeft: (props: any) => ({
      height: props.height,
      width: props.width,
      transform: `rotate(${props.rotation}deg)`,
      borderRadius: `${props.height}px 0 0 0`,
      MozBorderRadius: `${props.height}px 0 0 0`,
      WebkitBorderRadius: `${props.height}px 0 0 0`
    }),
    quarterCircleBottomRight: (props: any) => ({
      height: props.height,
      width: props.width,
      transform: `rotate(${props.rotation}deg)`,
      borderRadius: `0 0 ${props.height}px 0`,
      MozBorderRadius: `0 0 ${props.height}px 0`,
      WebkitBorderRadius: `0 0 ${props.height}px 0`
    }),
    quarterCircleBottomLeft: (props: any) => ({
      height: props.height,
      width: props.width,
      transform: `rotate(${props.rotation}deg)`,
      borderRadius: `0 0 0 ${props.height}px`,
      MozBorderRadius: `0 0 0 ${props.height}px`,
      WebkitBorderRadius: `0 0 0 ${props.height}px`
    }),
    quadrantArcTopRight: (props: any) => ({
      position: "relative",
      height: props.height,
      width: props.width,
      transform: `rotate(${props.rotation}deg)`,
      borderRadius: `0 ${props.height}px 0 0`,
      MozBorderRadius: `0 ${props.height}px 0 0`,
      WebkitBorderRadius: `0 ${props.height}px 0 0`,
      "&::after": {
        content: `""`,
        position: "absolute",
        bottom: -1,
        left: -1,
        backgroundColor: "#fafafa",
        height: "50%",
        width: "50%",
        borderRadius: `0 ${props.height / 2}px 0 0`,
        MozBorderRadius: `0 ${props.height / 2}px 0 0`,
        WebkitBorderRadius: `0 ${props.height / 2}px 0 0`
      }
    }),
    quadrantArcTopLeft: (props: any) => ({
      height: props.height,
      width: props.width,
      transform: `rotate(${props.rotation}deg)`,
      borderRadius: `${props.height}px 0 0 0`,
      MozBorderRadius: `${props.height}px 0 0 0`,
      WebkitBorderRadius: `${props.height}px 0 0 0`,
      "&::after": {
        content: `""`,
        position: "absolute",
        bottom: -1,
        right: -1,
        backgroundColor: "#fafafa",
        height: "50%",
        width: "50%",
        borderRadius: `${props.height / 2}px 0 0 0`,
        MozBorderRadius: `${props.height / 2}px 0 0 0`,
        WebkitBorderRadius: `${props.height / 2}px 0 0 0`
      }
    }),
    quadrantArcBottomRight: (props: any) => ({
      height: props.height,
      width: props.width,
      transform: `rotate(${props.rotation}deg)`,
      borderRadius: `0 0 ${props.height}px 0`,
      MozBorderRadius: `0 0 ${props.height}px 0`,
      WebkitBorderRadius: `0 0 ${props.height}px 0`,
      "&::after": {
        content: `""`,
        position: "absolute",
        top: -1,
        left: -1,
        backgroundColor: "#fafafa",
        height: "50%",
        width: "50%",
        borderRadius: `0 0 ${props.height / 2}px 0`,
        MozBorderRadius: `0 0 ${props.height / 2}px 0`,
        WebkitBorderRadius: `0 0 ${props.height / 2}px 0`
      }
    }),
    quadrantArcBottomLeft: (props: any) => ({
      height: props.height,
      width: props.width,
      transform: `rotate(${props.rotation}deg)`,
      borderRadius: `0 0 0 ${props.height}px`,
      MozBorderRadius: `0 0 0 ${props.height}px`,
      WebkitBorderRadius: `0 0 0 ${props.height}px`,
      "&::after": {
        content: `""`,
        position: "absolute",
        top: -1,
        right: -1,
        backgroundColor: "#fafafa",
        height: "50%",
        width: "50%",
        borderRadius: `0 0 0 ${props.height / 2}px`,
        MozBorderRadius: `0 0 0 ${props.height / 2}px`,
        WebkitBorderRadius: `0 0 0 ${props.height / 2}px`
      }
    }),
    rectangleWithCutOut: (props: any) => ({
      height: props.height,
      width: props.width,
      transform: `rotate(${props.rotation}deg)`,
      "&::after": {
        content: `""`,
        position: "absolute",
        bottom: -1,
        left: -1,
        backgroundColor: "#fafafa",
        height: "25%",
        width: "50%"
      }
    }),
    free: {
      backgroundColor: green[400],
      color: theme.palette.getContrastText(green[400]),
      "&:hover": {
        backgroundColor: darken(green[400], 0.1)
      },
      borderRadius: 0,
      cursor: "pointer"
    },
    selected: {
      backgroundColor: orange[400],
      color: theme.palette.getContrastText(orange[400]),
      "&:hover": {
        backgroundColor: darken(orange[400], 0.1)
      },
      borderRadius: 0,
      cursor: "pointer"
    },
    busy: {
      backgroundColor: red[400],
      color: theme.palette.getContrastText(red[400]),
      "&:hover": {
        backgroundColor: darken(red[400], 0.1)
      },
      borderRadius: 0,
      cursor: "not-allowed"
    },
    noAvailable: {
      backgroundColor: grey[400],
      color: theme.palette.getContrastText(grey[400]),
      "&:hover": {
        backgroundColor: darken(grey[400], 0.1)
      },
      borderRadius: 0,
      cursor: "not-allowed"
    },
    selectedSeat: {
      backgroundColor: orange[700],
      color: theme.palette.getContrastText(orange[700]),
      "&:hover": {
        backgroundColor: darken(orange[700], 0.1)
      },
      borderRadius: 10,
      cursor: "pointer"
    },
    customHandle: {
      position: "absolute",
      width: "8px",
      height: "8px",
      backgroundColor: "#1153aa",
      opacity: "0.75",
      borderRadius: "4px",
      bottom: "-4px",
      right: "-4px",
      cursor: "se-resize"
    },
    dragHandler: {
      position: "absolute",
      width: "8px",
      height: "8px",
      backgroundColor: "#ff9966",
      opacity: "0.75",
      borderRadius: "4px",
      top: "-4px",
      right: "-4px",
      cursor: "move"
    }
  })
);

const SeatView: React.FC<IProps> = ({
  title,
  top,
  left,
  width,
  height,
  shape,
  pictureUrl,
  rotation,
  colorClass,
  isSeatSelected = false,
  status,
  textTooltip
}: IProps) => {
  const classes = useStyles({ width, height, top, left, pictureUrl, rotation });

  // @ts-ignore
  const getClassName = () => classes[colorClass];

  const getClassNameByShape = (shape: string) => {
    if (shape === "circle") {
      return classes.CIRCLE;
    } else if (shape === "quarterCircleTopRight") {
      return classes.quarterCircleTopRight;
    } else if (shape === "quarterCircleTopLeft") {
      return classes.quarterCircleTopLeft;
    } else if (shape === "quarterCircleBottomRight") {
      return classes.quarterCircleBottomRight;
    } else if (shape === "quarterCircleBottomLeft") {
      return classes.quarterCircleBottomLeft;
    } else if (shape === "quadrantArcTopRight") {
      return classes.quadrantArcTopRight;
    } else if (shape === "quadrantArcTopLeft") {
      return classes.quadrantArcTopLeft;
    } else if (shape === "quadrantArcBottomRight") {
      return classes.quadrantArcBottomRight;
    } else if (shape === "quadrantArcBottomLeft") {
      return classes.quadrantArcBottomLeft;
    } else if (shape === "rectangleWithCutOut") {
      return classes.rectangleWithCutOut;
    } else {
      return classes.SQUARE;
    }
  };

  return (
    <Tooltip
      title={
        status === "X" || status === "I" ? (
          <React.Fragment>
            <div dangerouslySetInnerHTML={{ __html: textTooltip }} />
          </React.Fragment>
        ) : (
          ""
        )
      }
    >
      {isSeatSelected ? (
        <div className={`${getClassNameByShape(shape)} ${classes.divSeat} ${classes.selectedSeat}`}>
          <span>{title ?? ""}</span>
        </div>
      ) : (
        <div className={`${getClassNameByShape(shape)} ${classes.divSeat} ${getClassName()}`}>
          <span>{title ?? ""}</span>
        </div>
      )}
    </Tooltip>
  );
};
export default SeatView;
